import { render, staticRenderFns } from "./ImageTranslator.vue?vue&type=template&id=a4656830&scoped=true&"
import script from "./ImageTranslator.vue?vue&type=script&lang=js&"
export * from "./ImageTranslator.vue?vue&type=script&lang=js&"
import style0 from "./ImageTranslator.vue?vue&type=style&index=0&id=a4656830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4656830",
  null
  
)

export default component.exports